import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {Dialog} from 'shells/dialog/dialog';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconReportsIcon} from 'shells/icon/svg/sidebar-icon-reports';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';

import {appHistory} from '../../../../history';

type Props = {
    onDeleteSource: () => void | null | undefined;
    reportUrl: string;
    name: string;
};

export function SourceRowActionMenu(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const actionMenuRef = React.useRef();

    const options = [
        {
            label: 'View report',
            handleSelect: () => appHistory.push(props.reportUrl),
            icon: <SidebarIconReportsIcon size={16} />,
        },
    ];

    if (props.onDeleteSource) {
        options.push({
            label: 'Delete',
            handleSelect: props.onDeleteSource,
            icon: <TrashIcon size={16} />,
            // @ts-expect-error
            variant: 'destructive',
        });
    }

    return (
        <>
            <ActionMenu
                options={options}
                getRef={(node) => {
                    // @ts-expect-error
                    actionMenuRef.current = node;
                }}
                size='small'
                hasHoverBackground={true}
            />
            {isConfirmingDelete && props.onDeleteSource ? (
                <Dialog
                    anchor={actionMenuRef.current}
                    location='top'
                    question={`Are you sure you want to delete ${props.name}?`}
                    onPrimary={props.onDeleteSource}
                    onSecondary={() => setIsConfirmingDelete(false)}
                    isWarning={true}
                />
            ) : undefined}
        </>
    );
}
